import React from "react";

const Context = React.createContext<string>("");

function useLogoLoader() {
  return React.useContext(Context);
}

export { Context, useLogoLoader };
